<template>
  <div style="align-items: baseline" class="justify-center">
    <div class="text-center">
      <img :src="headerLogo" class="img-logo" alt="Avatar">
    </div>
    <div class="mt-2 justify-center" style="display: flex; margin-bottom: 13px;">
      <div class="app-name-panel">{{ textItem }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["textItem", "headerLogo"]
};
</script>

<style>
.img-logo {
  width: 28vw;
}

@media screen and (max-width: 767px) {
  .img-logo {
    width: 100%;
  }

  .app-name-panel {
    font-size: 18px;
  }
}
</style>
